import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import AuthCallback from "@/pages/AuthCallback";
import { Toaster } from "@/components/ui/sonner";
import { InstallPrompt } from "@/components/InstallPrompt";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Ingredients from "@/pages/Ingredients";
import Recipes from "@/pages/Recipes";
import Stock from "@/pages/Stock";
import Sales from "@/pages/Sales";
import Retail from "@/pages/Retail";
import RetailStock from "@/pages/RetailStock";
import MyHerbalife from "@/pages/MyHerbalife";
import SalesHistory from "@/pages/SalesHistory";
import Finances from "@/pages/Finances";
import Reports from "@/pages/Reports";
import ZReport from "@/pages/ZReport";
import Club from "@/pages/Club";
import Register from "@/pages/Register";
import Settings from "@/pages/Settings";
import Users from "@/pages/Users";
import Guide from "@/pages/Guide";
import { PermissionsProvider } from "@/context/PermissionsContext";

const withLayout = (el, page) => (
  <ProtectedRoute page={page}>
    <Layout>{el}</Layout>
  </ProtectedRoute>
);

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/" element={withLayout(<Dashboard />, "dashboard")} />
            <Route path="/malzemeler" element={withLayout(<Ingredients />, "ingredients")} />
            <Route path="/urunler" element={withLayout(<Recipes />, "recipes")} />
            <Route path="/stok" element={withLayout(<Stock />, "stock")} />
            <Route path="/satis" element={withLayout(<Sales />, "sales")} />
            <Route path="/perakende" element={withLayout(<Retail />, "retail")} />
            <Route path="/perakende-stok" element={withLayout(<RetailStock />, "retail_stock")} />
            <Route path="/myherbalife" element={withLayout(<MyHerbalife />, "myherbalife")} />
            <Route path="/satis-gecmisi" element={withLayout(<SalesHistory />, "sales")} />
            <Route path="/finans" element={withLayout(<Finances />, "finances")} />
            <Route path="/raporlar" element={withLayout(<Reports />, "reports")} />
            <Route path="/tarifler" element={withLayout(<Guide />, "guide")} />
            <Route path="/z-raporu" element={withLayout(<ZReport />, "zreport")} />
      <Route path="/kulup" element={withLayout(<Club />, "club")} />
            <Route path="/ayarlar" element={withLayout(<Settings />, "settings")} />
            <Route path="/kullanicilar" element={withLayout(<Users />, "users")} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <PermissionsProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        </PermissionsProvider>
        <Toaster position="top-right" richColors />
        <InstallPrompt />
      </AuthProvider>
    </div>
  );
}

export default App;
